// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders_mainWrapper__lXmEO {
    height: -moz-fit-content;
    height: fit-content;
    padding: 0 10px;
  }
  
  .orders_formWrapper__YoteZ {
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    overflow-y: scroll;
  }
  
  .orders_registrationTitle__7EyRt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 24px;
    max-width: 1080px;
  }
  
  .orders_registrationConfigRoot__FmJyF {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
  }
  
  
  
  
  .orders_labelAndButtonWrapper__6TIDF {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    align-items: center;
    margin-bottom: 2px;
    gap: 10px;
  }
  
  .orders_titleWrapper__ymJNG {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  
  .orders_checkboxWraper__RdVy6 {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
    gap: 8px;
  }
  
  .orders_labelCheckBox__Nxk-v {
    font-size: 14px;
    font-weight: 500;
  }
  
  .orders_labelAndErrorWrapper__YEz6F {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    align-items: center;
  }
  
  .orders_orgTitleMain__-d88v {
    font-weight: 600;
  }
  
  @media screen and (max-width: 600px) {
    .orders_label-and-error-wrapper__eFRKX {
      margin-top: 10px;
    }
  }
  
  .orders_subjectBlockConfigRoot__Ki768 {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px 16px;
    margin-bottom: 12px;
  }
  
  .orders_blockConfigRoot__9hhd1 {
    background-color: #fff;
    padding-top: 30px;
    gap: 10px;
    width: 100%;
  }
  
  .orders_buttonBlock__PVf6x {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    max-width: 100%;
    margin-bottom: 16px;
  }
  
  .orders_buttonConfigRoot__dLLla {
    background-color: #fff;
    border-radius: 8px;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .orders_formAddButton__dq3hO {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  
  .orders_formAddButton__dq3hO span {
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
  }
  
  .orders_formAddButton__dq3hO img {
    flex-shrink: 0;
  }
  
  .orders_formAddButton__dq3hO:hover {
    background-color: #f3f7f7;
  }
  
  .orders_formButton__gKBLm {
    display: flex;
    flex-direction: row;
    max-width: 100%;
    gap: 8px;
  }
  
  .orders_inputField__VphXS {
    /* max-width: 256px; */
    /* flex: 1 1 calc(50% - 10px); */
    /* max-width: calc(50% - 8px); */
    font-family: "Inter", sans-serif;
    font-weight: 700;
    line-height: 19.6px;
    color: #2e3138;
    width: 100%;
    min-width: 150px;
  }
  
  .orders_inputField1__v\\+3yG {
    /* max-width: 256px; */
    /* flex: 1 1 calc(50% - 10px); */
    /* max-width: calc(50% - 8px); */
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    color: #2e3138;
    margin-bottom: 8px;
    
    width: 100%;
    min-width: 150px;
  }
  
  .orders_inputField1__v\\+3yG .orders_placeholder__Tzn4V,
  .orders_inputField1__v\\+3yG input {
    width: 100%;
    height: 40px;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
    padding-left: 10px;
    font-size: 14px;
    color: #2e3138;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    margin: 0;
    outline: none;
  }
  
  .orders_selectField__qrn9H {
    width: 100%;
    height: 48px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    padding: 8px;
    margin: 0;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
  }
  
  .orders_inputField__VphXS .orders_placeholder__Tzn4V,
  .orders_inputField__VphXS input {
    width: 100%;
    height: 40px;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
    padding-left: 10px;
    font-size: 12px;
    color: #2e3138;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    margin: 0;
    outline: none;
  }
  
  .orders_inputField__VphXS input:hover {
    border-color: #8ea3b0;
  }
  
  .orders_inputField__VphXS input:focus {
    border-color: #0c6154;
    border-width: 1px;
  }
  
  .orders_inputField__VphXS input::placeholder {
    color: #a3c0d2;
    font-weight: 400;
    font-size: 14px;
  }
  
  .orders_inputField__VphXS input.orders_-error__ez2pJ {
    border-color: #ed1e1e;
  }
  
  .orders_inputField1__v\\+3yG input:hover {
    border-color: #8ea3b0;
  }
  
  .orders_inputField1__v\\+3yG input:focus {
    border-color: #0c6154;
    border-width: 1px;
  }
  
  .orders_inputField1__v\\+3yG input::placeholder {
    color: #a3c0d2;
    font-weight: 400;
    font-size: 14px;
  }
  
  .orders_inputField1__v\\+3yG input.orders_-error__ez2pJ {
    border-color: #ed1e1e;
  }
  
  .orders_buttonForm__TzM1T {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33% - 8px);
  }
  
  .orders_errorLabel__NLCxW {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: rgb(249, 52, 30);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .orders_labelAndErrorWrapper__YEz6F {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    align-items: center;
  }
  
  .orders_customFileInput__8Dez8 {
    position: relative;
    padding: 10px;
    border-radius: 5px;
    background: rgba(9, 172, 113, 0.05);
    border: 2px dashed rgba(29, 190, 166, 0.69);
    color: rgba(29, 190, 166, 0.69);
    font-weight: 300;
    width: 100%;
    height: 40px;
  }
  
  .orders_customFileInput__8Dez8 input[type="file"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  
  .orders_fileName__O6ea5 {
    padding: 9px;
    border-radius: 5px;
    background: rgba(255, 222, 217, 0.69);
    border: 2px dashed rgba(232, 55, 28, 0.69);
    color: rgba(29, 190, 166, 0.69);
    font-weight: 300;
    width: 100%;
    height: 40px;
    display: flex;
    gap: 20px;
    justify-content: space-between;
  }
  
  .orders_inputField4__LPxPR {
    /* max-width: 256px; */
    /* flex: 1 1 calc(50% - 10px); */
    /* max-width: calc(50% - 8px); */
    max-width: calc(33% - 10px);
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    color: #2e3138;
    margin-bottom: 8px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33% - 20px);
    width: 100%;
    min-width: 150px;
    box-sizing: content-box;
  }
  .orders_inputField3__y7muC {
    /* max-width: 256px; */
    /* flex: 1 1 calc(50% - 10px); */
    /* max-width: calc(50% - 8px); */
    max-width: calc(33% - 12px);
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    color: #2e3138;
    margin-bottom: 8px;
    width: 100%;
    min-width: 150px;
  }

  .orders_custom_underline__bPpiu {
    text-decoration: underline;
    text-decoration-color: currentColor;
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;
    }
    .orders_tooltipWrapper__P6ZVE {
      position: relative;
      display: flex;
      cursor: pointer;
      gap: 10px;
      align-items: center; 
    }
    
    .orders_tooltipText__OF\\+Jc {
      visibility: hidden; 
      width: 150px;
      background-color: rgba(0, 0, 0, 0.75); 
      color: #fff; 
      text-align: center;
      border-radius: 4px; 
      padding: 5px 10px; 
      position: absolute;
      z-index: 10; 
      bottom: 125%; 
      left: 50%;
      transform: translateX(-50%);
      opacity: 0; 
      transition: opacity 0.3s ease-in-out;
      font-size: 12px;
      pointer-events: none; 
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); 
    }
    
    .orders_tooltipWrapper__P6ZVE:hover .orders_tooltipText__OF\\+Jc {
      visibility: visible;
      opacity: 1;
      position: absolute;
    }
    
    .orders_errorIcon__42D3f {
      color: rgb(102, 94, 94); /* Цвет иконки */
      width: 16px; /* Размер иконки */
      height: 13px;
      display: inline-block;
    }`, "",{"version":3,"sources":["webpack://./src/pages/Orders/orders.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAmB;IAAnB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,aAAa;EACf;;;;;EAKA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;;IAElB,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,mCAAmC;IACnC,2CAA2C;IAC3C,+BAA+B;IAC/B,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,0CAA0C;IAC1C,+BAA+B;IAC/B,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,2BAA2B;IAC3B,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,2BAA2B;IAC3B,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,mCAAmC;IACnC,8BAA8B;IAC9B,0BAA0B;IAC1B;IACA;MACE,kBAAkB;MAClB,aAAa;MACb,eAAe;MACf,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,qCAAqC;MACrC,WAAW;MACX,kBAAkB;MAClB,kBAAkB;MAClB,iBAAiB;MACjB,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,SAAS;MACT,2BAA2B;MAC3B,UAAU;MACV,oCAAoC;MACpC,eAAe;MACf,oBAAoB;MACpB,0CAA0C;IAC5C;;IAEA;MACE,mBAAmB;MACnB,UAAU;MACV,kBAAkB;IACpB;;IAEA;MACE,uBAAuB,EAAE,gBAAgB;MACzC,WAAW,EAAE,kBAAkB;MAC/B,YAAY;MACZ,qBAAqB;IACvB","sourcesContent":[".mainWrapper {\n    height: fit-content;\n    padding: 0 10px;\n  }\n  \n  .formWrapper {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    overflow-y: scroll;\n  }\n  \n  .registrationTitle {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0 24px;\n    max-width: 1080px;\n  }\n  \n  .registrationConfigRoot {\n    background-color: #fff;\n    width: 100%;\n    border-radius: 8px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 16px;\n  }\n  \n  \n  \n  \n  .labelAndButtonWrapper {\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n    align-items: center;\n    margin-bottom: 2px;\n    gap: 10px;\n  }\n  \n  .titleWrapper {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n  }\n  \n  .checkboxWraper {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    gap: 8px;\n  }\n  \n  .labelCheckBox {\n    font-size: 14px;\n    font-weight: 500;\n  }\n  \n  .labelAndErrorWrapper {\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n    align-items: center;\n  }\n  \n  .orgTitleMain {\n    font-weight: 600;\n  }\n  \n  @media screen and (max-width: 600px) {\n    .label-and-error-wrapper {\n      margin-top: 10px;\n    }\n  }\n  \n  .subjectBlockConfigRoot {\n    background-color: #fff;\n    width: 100%;\n    border-radius: 8px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 16px;\n    margin-bottom: 12px;\n  }\n  \n  .blockConfigRoot {\n    background-color: #fff;\n    padding-top: 30px;\n    gap: 10px;\n    width: 100%;\n  }\n  \n  .buttonBlock {\n    display: flex;\n    justify-content: flex-start;\n    gap: 10px;\n    max-width: 100%;\n    margin-bottom: 16px;\n  }\n  \n  .buttonConfigRoot {\n    background-color: #fff;\n    border-radius: 8px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .formAddButton {\n    background-color: #fff;\n    width: 100%;\n    border-radius: 8px;\n    padding: 10px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .formAddButton span {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    overflow: hidden;\n  }\n  \n  .formAddButton img {\n    flex-shrink: 0;\n  }\n  \n  .formAddButton:hover {\n    background-color: #f3f7f7;\n  }\n  \n  .formButton {\n    display: flex;\n    flex-direction: row;\n    max-width: 100%;\n    gap: 8px;\n  }\n  \n  .inputField {\n    /* max-width: 256px; */\n    /* flex: 1 1 calc(50% - 10px); */\n    /* max-width: calc(50% - 8px); */\n    font-family: \"Inter\", sans-serif;\n    font-weight: 700;\n    line-height: 19.6px;\n    color: #2e3138;\n    width: 100%;\n    min-width: 150px;\n  }\n  \n  .inputField1 {\n    /* max-width: 256px; */\n    /* flex: 1 1 calc(50% - 10px); */\n    /* max-width: calc(50% - 8px); */\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    color: #2e3138;\n    margin-bottom: 8px;\n    \n    width: 100%;\n    min-width: 150px;\n  }\n  \n  .inputField1 .placeholder,\n  .inputField1 input {\n    width: 100%;\n    height: 40px;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n    padding-left: 10px;\n    font-size: 14px;\n    color: #2e3138;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    margin: 0;\n    outline: none;\n  }\n  \n  .selectField {\n    width: 100%;\n    height: 48px;\n    flex: 1 1 calc(50% - 10px);\n    padding: 8px;\n    margin: 0;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n  }\n  \n  .inputField .placeholder,\n  .inputField input {\n    width: 100%;\n    height: 40px;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n    padding-left: 10px;\n    font-size: 12px;\n    color: #2e3138;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    margin: 0;\n    outline: none;\n  }\n  \n  .inputField input:hover {\n    border-color: #8ea3b0;\n  }\n  \n  .inputField input:focus {\n    border-color: #0c6154;\n    border-width: 1px;\n  }\n  \n  .inputField input::placeholder {\n    color: #a3c0d2;\n    font-weight: 400;\n    font-size: 14px;\n  }\n  \n  .inputField input.-error {\n    border-color: #ed1e1e;\n  }\n  \n  .inputField1 input:hover {\n    border-color: #8ea3b0;\n  }\n  \n  .inputField1 input:focus {\n    border-color: #0c6154;\n    border-width: 1px;\n  }\n  \n  .inputField1 input::placeholder {\n    color: #a3c0d2;\n    font-weight: 400;\n    font-size: 14px;\n  }\n  \n  .inputField1 input.-error {\n    border-color: #ed1e1e;\n  }\n  \n  .buttonForm {\n    flex: 1 1 calc(33% - 8px);\n  }\n  \n  .errorLabel {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 14px;\n    color: rgb(249, 52, 30);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .labelAndErrorWrapper {\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n    align-items: center;\n  }\n  \n  .customFileInput {\n    position: relative;\n    padding: 10px;\n    border-radius: 5px;\n    background: rgba(9, 172, 113, 0.05);\n    border: 2px dashed rgba(29, 190, 166, 0.69);\n    color: rgba(29, 190, 166, 0.69);\n    font-weight: 300;\n    width: 100%;\n    height: 40px;\n  }\n  \n  .customFileInput input[type=\"file\"] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n  }\n  \n  .fileName {\n    padding: 9px;\n    border-radius: 5px;\n    background: rgba(255, 222, 217, 0.69);\n    border: 2px dashed rgba(232, 55, 28, 0.69);\n    color: rgba(29, 190, 166, 0.69);\n    font-weight: 300;\n    width: 100%;\n    height: 40px;\n    display: flex;\n    gap: 20px;\n    justify-content: space-between;\n  }\n  \n  .inputField4 {\n    /* max-width: 256px; */\n    /* flex: 1 1 calc(50% - 10px); */\n    /* max-width: calc(50% - 8px); */\n    max-width: calc(33% - 10px);\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    color: #2e3138;\n    margin-bottom: 8px;\n    flex: 1 1 calc(33% - 20px);\n    width: 100%;\n    min-width: 150px;\n    box-sizing: content-box;\n  }\n  .inputField3 {\n    /* max-width: 256px; */\n    /* flex: 1 1 calc(50% - 10px); */\n    /* max-width: calc(50% - 8px); */\n    max-width: calc(33% - 12px);\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    color: #2e3138;\n    margin-bottom: 8px;\n    width: 100%;\n    min-width: 150px;\n  }\n\n  .custom_underline {\n    text-decoration: underline;\n    text-decoration-color: currentColor;\n    text-decoration-thickness: 1px;\n    text-underline-offset: 3px;\n    }\n    .tooltipWrapper {\n      position: relative;\n      display: flex;\n      cursor: pointer;\n      gap: 10px;\n      align-items: center; \n    }\n    \n    .tooltipText {\n      visibility: hidden; \n      width: 150px;\n      background-color: rgba(0, 0, 0, 0.75); \n      color: #fff; \n      text-align: center;\n      border-radius: 4px; \n      padding: 5px 10px; \n      position: absolute;\n      z-index: 10; \n      bottom: 125%; \n      left: 50%;\n      transform: translateX(-50%);\n      opacity: 0; \n      transition: opacity 0.3s ease-in-out;\n      font-size: 12px;\n      pointer-events: none; \n      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); \n    }\n    \n    .tooltipWrapper:hover .tooltipText {\n      visibility: visible;\n      opacity: 1;\n      position: absolute;\n    }\n    \n    .errorIcon {\n      color: rgb(102, 94, 94); /* Цвет иконки */\n      width: 16px; /* Размер иконки */\n      height: 13px;\n      display: inline-block;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainWrapper": `orders_mainWrapper__lXmEO`,
	"formWrapper": `orders_formWrapper__YoteZ`,
	"registrationTitle": `orders_registrationTitle__7EyRt`,
	"registrationConfigRoot": `orders_registrationConfigRoot__FmJyF`,
	"labelAndButtonWrapper": `orders_labelAndButtonWrapper__6TIDF`,
	"titleWrapper": `orders_titleWrapper__ymJNG`,
	"checkboxWraper": `orders_checkboxWraper__RdVy6`,
	"labelCheckBox": `orders_labelCheckBox__Nxk-v`,
	"labelAndErrorWrapper": `orders_labelAndErrorWrapper__YEz6F`,
	"orgTitleMain": `orders_orgTitleMain__-d88v`,
	"label-and-error-wrapper": `orders_label-and-error-wrapper__eFRKX`,
	"subjectBlockConfigRoot": `orders_subjectBlockConfigRoot__Ki768`,
	"blockConfigRoot": `orders_blockConfigRoot__9hhd1`,
	"buttonBlock": `orders_buttonBlock__PVf6x`,
	"buttonConfigRoot": `orders_buttonConfigRoot__dLLla`,
	"formAddButton": `orders_formAddButton__dq3hO`,
	"formButton": `orders_formButton__gKBLm`,
	"inputField": `orders_inputField__VphXS`,
	"inputField1": `orders_inputField1__v+3yG`,
	"placeholder": `orders_placeholder__Tzn4V`,
	"selectField": `orders_selectField__qrn9H`,
	"-error": `orders_-error__ez2pJ`,
	"buttonForm": `orders_buttonForm__TzM1T`,
	"errorLabel": `orders_errorLabel__NLCxW`,
	"customFileInput": `orders_customFileInput__8Dez8`,
	"fileName": `orders_fileName__O6ea5`,
	"inputField4": `orders_inputField4__LPxPR`,
	"inputField3": `orders_inputField3__y7muC`,
	"custom_underline": `orders_custom_underline__bPpiu`,
	"tooltipWrapper": `orders_tooltipWrapper__P6ZVE`,
	"tooltipText": `orders_tooltipText__OF+Jc`,
	"errorIcon": `orders_errorIcon__42D3f`
};
export default ___CSS_LOADER_EXPORT___;
